import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateBettingSelectionMapping } from "@/api/bettingSelections";
import { BettingSelectionsQueryKeys } from "@/tanstackQuery/queries/bettingSelections";
import { UpdateBettingSelectionMappingParams } from "@/types/ApiResponses/BettingSelection";

export const useUpdateBettingSelectionMapping = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: UpdateBettingSelectionMappingParams) => updateBettingSelectionMapping(params),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [BettingSelectionsQueryKeys.BettingSelectionMappings, variables.selectionId],
      });
    },
  });
};
